export const REMINDER_SOUND_KEY = "ql-reminder-sound-enabled";

export const toLocalDateTimeInput = (isoValue) => {
  if (!isoValue) return "";
  const date = new Date(isoValue);
  if (Number.isNaN(date.getTime())) return "";
  const pad = value => String(value).padStart(2, "0");
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T${pad(date.getHours())}:${pad(date.getMinutes())}`;
};

export const fromLocalDateTimeInput = (localValue) => {
  if (!localValue) return null;
  const date = new Date(localValue);
  return Number.isNaN(date.getTime()) ? null : date.toISOString();
};

export const taskStatus = (task, now = Date.now()) => {
  if (task.completed) return "completed";
  if (!task.due_at) return "undated";
  return new Date(task.due_at).getTime() < now ? "overdue" : "upcoming";
};

export const deliverTaskReminder = ({ task, NotificationApi, onInApp, onOpen }) => {
  onInApp(task);
  if (!NotificationApi || NotificationApi.permission !== "granted") return false;
  const notification = new NotificationApi("Rappel Quick Learning", { body: task.text, tag: `ql-task-${task.id}` });
  notification.onclick = () => onOpen(task);
  return true;
};

export const createTaskReminderManager = ({ storage, notify, playSound, setTimer = setTimeout, clearTimer = clearTimeout, now = () => Date.now() }) => {
  const timers = new Map();
  const cancelAll = () => {
    timers.forEach(timer => clearTimer(timer));
    timers.clear();
  };
  const sync = (tasks, { soundEnabled = true } = {}) => {
    cancelAll();
    tasks.filter(task => task.reminder_enabled && task.due_at && !task.completed).forEach(task => {
      const dueAt = new Date(task.due_at).getTime();
      const reminderKey = `ql-reminder-fired:${task.id}:${task.reminder_revision}:${task.due_at}`;
      if (!Number.isFinite(dueAt) || storage.getItem(reminderKey)) return;
      const fire = () => {
        if (storage.getItem(reminderKey)) return;
        storage.setItem(reminderKey, "1");
        notify(task);
        if (soundEnabled) playSound();
        timers.delete(task.id);
      };
      const schedule = () => {
        const remaining = Math.max(0, dueAt - now());
        if (remaining > 2147483647) {
          timers.set(task.id, setTimer(schedule, 2147483647));
        } else {
          timers.set(task.id, setTimer(fire, remaining));
        }
      };
      schedule();
    });
  };
  return { sync, cancelAll };
};
